'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
require('../../extends-733dd656.js');
require('../../objectWithoutProperties-c6d3675c.js');
require('react');
require('../../index-7124f64c.js');
require('../../taggedTemplateLiteral-f923b98d.js');
require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../unsupportedIterableToArray-f175acfa.js');
require('../../breakpoints-ee0a4ae5.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
require('../../styles/themeUtils.js');
var components_Icon_Icon = require('../../Icon-efcd1bee.js');



exports.default = components_Icon_Icon.Icon;
//# sourceMappingURL=Icon.js.map
